import { render } from "./process-design-viewer.html?vue&type=template&id=7d0bd5d8&scoped=true&ts=true"
import script from "./process-design-viewer.ts?vue&type=script&lang=ts"
export * from "./process-design-viewer.ts?vue&type=script&lang=ts"

import "./process-design-viewer.scss?vue&type=style&index=0&id=7d0bd5d8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0bd5d8"]])

export default __exports__